var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A82939;}\n\t.st1{fill:none;stroke:#75232E;stroke-width:5;}\n\t.st2{fill:#A21B2C;}\n\t.st3{fill:none;stroke:#75232E;stroke-width:4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,58h23.8v-4.9h-9.2c-1.8,0-4.1,0.2-6,0.3c7.8-7.4,13.5-14.8,13.5-21.9c0-6.7-4.4-11.1-11.1-11.1 c-4.8,0-8,2.1-11.2,5.5l3.2,3.2c1.9-2.2,4.3-4.1,7.2-4.1c4.1,0,6.2,2.8,6.2,6.8c0,6.1-5.6,13.2-16.5,22.8V58z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 40,
    cy: 40,
    r: 37.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.412b1c6a.svg";
export { ForwardRef as ReactComponent };